import { WaveBlockKind } from "./types.js";
import { waveTodoCategories, waveTodoMirrorId } from "./waveTodoTags.js";
import { WaveCloudAPI } from "./graphql/waveApi.js";
/** Flatten markdown/leading emoji for cloud Todo text; keep @mentions as visible task text. */
function mirrorTextForCloud(text) {
    return text
        .replace(/^[\p{Extended_Pictographic}\uFE0F\s]+/u, "")
        .replace(/\*\*\*(.+?)\*\*\*/g, "$1")
        .replace(/\*\*(.+?)\*\*/g, "$1")
        .replace(/\*(.+?)\*/g, "$1")
        .replace(/\s{2,}/g, " ")
        .trim();
}
function priorityFromItem(raw) {
    const p = (raw ?? "none").toLowerCase();
    if (p === "high" || p === "medium" || p === "low")
        return p.toUpperCase();
    return "NONE";
}
function dueDateFromISO(iso) {
    if (!iso?.trim())
        return null;
    const d = new Date(iso);
    if (Number.isNaN(d.getTime()))
        return null;
    return d.toISOString().slice(0, 10);
}
/** Collect all TODO_LIST items from materialized blocks for mirror sync. */
export function collectWaveTodoMirrorRows(blocks, ctx) {
    const rows = [];
    for (const block of blocks) {
        if (block.kind !== WaveBlockKind.TodoList)
            continue;
        const widgetIndex = block.payload.widgetIndex ?? 1;
        const categories = waveTodoCategories(ctx.spaceId, ctx.waveId, widgetIndex);
        const projectId = block.payload.projectId ?? ctx.projectId ?? ctx.spaceId;
        for (const item of block.payload.todoItems ?? []) {
            const plain = mirrorTextForCloud(item.title);
            if (!plain)
                continue;
            rows.push({
                todoId: waveTodoMirrorId(ctx.waveId, block.id, item.id),
                blockId: block.id,
                itemId: item.id,
                text: plain,
                completed: item.done,
                categories,
                projectId,
                priority: priorityFromItem(item.priority),
                dueDate: dueDateFromISO(item.dueDateISO),
            });
        }
    }
    return rows;
}
/** Idempotent per-user mirror of Wave todo items into cloud Todo rows. */
export async function mirrorWaveTodoItemsToCloud(cfg, blocks, ctx) {
    const rows = collectWaveTodoMirrorRows(blocks, ctx);
    const errors = [];
    let synced = 0;
    for (const row of rows) {
        try {
            // updateTodo resolver is upsert-safe; createTodo uses attribute_not_exists(PK).
            await WaveCloudAPI.updateTodo(cfg, row.todoId, {
                text: row.text,
                completed: row.completed,
                categories: row.categories,
                projectId: row.projectId ?? undefined,
                priority: row.priority,
                dueDate: row.dueDate ?? undefined,
            });
            synced += 1;
        }
        catch (updateErr) {
            const msg = updateErr instanceof Error ? updateErr.message : "sync failed";
            errors.push(`${row.todoId}: ${msg}`);
        }
    }
    return { synced, errors };
}
